import { Paginated } from './pagination';
import { HttpParams } from '@angular/common/http';
import { BaseModel } from '@app/shared/models/base';

export class SearchParams implements Paginated {
    public step: number;
    public columns: string;
    public filter: string;
    public start: number;
    public limit: number;
    public search: SearchTerm[];
    public desc: boolean;

    get from(): number {
        return this.start;
    }
   
    constructor(step?: number) {
        this.start = 0;
        this.step = step ? step : 5;
        this.limit = this.start + this.step;
    }

    public setShowMore(maxRowCount: number): void {
        if (maxRowCount > this.limit) {
            this.limit += this.step;
        }
    }

    public setShowLess(): void {
        if (this.limit > this.step) {
            this.limit -= this.step;
        }
    }

    public getAsHttpParams(): HttpParams {
        return new HttpParams().set('start', this.start || this.start === 0 ? this.start.toString() : '')
                               .set('limit', this.limit || this.limit === 0 ? this.limit.toString() : '')
                               .set('fields', this.columns ? this.columns : '')
                               .set('filter', this.filter ? this.filter : '')
                               .set('search', this.getSearchTermsAsString())
                               .set('desc', this.desc ? String(this.desc) : '');
    }

    protected getSearchTermsAsString(): string {
        if (this.search && this.search.length > 0) {
            if (this.search.length === 1) {
                return this.search[0].asSearchParam;
            } else {
                return this.search.map(term => term.asSearchParam).join(',');
            }
        } else {
            return '';
        }
    }
}

export class SearchTerm extends BaseModel {
    public term: string;
    public suggestion?: string;
    public suggestionTransKey?: string;
    public value?: number;

    get asSearchParam(): string {
        return this.suggestion ? `${this.suggestion}:${this.term}` : this.term;
    }

    constructor(json?: any) {
        super(json);
    }
}

export class SearchSuggestionList extends BaseModel {
    public term: string;
    public suggestions: SearchTerm[];

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            suggestions: json && json.suggestions ? json.suggestions.map(suggestion => new SearchTerm(Object.assign({ term: json.term }, suggestion))) : []
        });
    }
}
